import { StackScreen } from '@banhala/ui-kit';
import { useHandleBackPressed } from 'shared/src/hooks';
import {
  useGetCommonParams,
  useSetScreenName,
  useReportTTFD,
} from '../../hooks';
import { CartIcon, ScreensResult, SearchIcon } from '../../components';
import { FilterListAtomicProvider } from 'shared/src/component';
import { useState } from 'react';

export const Screens = () => {
  const { instanceId } = useGetCommonParams();
  const { showBackButton, onPressBack } = useHandleBackPressed(instanceId);
  const [title, setTitle] = useState<string | undefined>(undefined);

  useSetScreenName();
  useReportTTFD();

  return (
    <StackScreen
      title={title}
      hideBackButton={!showBackButton}
      onPressBack={onPressBack}
      rightIcons={[<SearchIcon />, <CartIcon />]}
    >
      <FilterListAtomicProvider>
        <ScreensResult setTitle={setTitle} />
      </FilterListAtomicProvider>
    </StackScreen>
  );
};
